import React, { useEffect, useRef, useState } from 'react';
import api from '../../services/api';
import { Button } from './design-system';

export default function ProtectedDocument({ url, title = 'Documento' }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const objectUrl = useRef(null);
  useEffect(() => () => {
    if (objectUrl.current) URL.revokeObjectURL(objectUrl.current);
  }, []);

  const download = async () => {
    setLoading(true);
    setError('');
    try {
      // Only the fixed local API path receives credentials, never a provider URL.
      const parsed = new URL(url, window.location.origin);
      if (!parsed.pathname.startsWith('/api/private-media/')) throw new Error('Invalid document endpoint');
      const response = await api.get(parsed.pathname.slice(4), { responseType: 'blob' });
      if (objectUrl.current) URL.revokeObjectURL(objectUrl.current);
      objectUrl.current = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = objectUrl.current;
      const extension = {
        'application/pdf': '.pdf', 'image/jpeg': '.jpg', 'image/png': '.png',
        'image/gif': '.gif', 'image/webp': '.webp',
      }[response.data.type] || '.bin';
      link.download = title + extension;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch {
      setError('No se pudo descargar el documento. Verifica tu acceso e intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  if (!url) return <span>No adjunto</span>;
  return <div>
    <Button variant="secondary" loading={loading} onClick={download}>Descargar {title}</Button>
    {error && <p role="alert">{error}</p>}
  </div>;
}
